/** Custom validators for Handsontable */
import type Handsontable from 'handsontable';
import {
  textMetadataInVivoValidator,
  dateMetadataInVivoValidator,
  numberMetadataInVivoValidator,
  fromInVivoValidator,
} from '@/support/hotValidator.util';

export const validators = {
  metadata: {
    text: 'in-vivo-text-metadata',
    date: 'in-vivo-date-metadata',
    number: 'in-vivo-number-metadata',
  },
} as const;

type ValidatorFn = (this: unknown, value: unknown, callback: (valid: boolean) => void) => void;

export const registerCustomValidators = (HandsontableInstance: typeof Handsontable): void => {
  HandsontableInstance.validators.registerValidator(
    validators.metadata.text,
    fromInVivoValidator(textMetadataInVivoValidator) as ValidatorFn
  );
  HandsontableInstance.validators.registerValidator(
    validators.metadata.date,
    fromInVivoValidator(dateMetadataInVivoValidator) as ValidatorFn
  );
  HandsontableInstance.validators.registerValidator(
    validators.metadata.number,
    fromInVivoValidator(numberMetadataInVivoValidator) as ValidatorFn
  );
};
